import { useState } from "react";
import { Link } from "react-router-dom";
import { forgotPassword } from "../../api/auth.api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setError("Enter the email you signed up with");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await forgotPassword(email.trim());
      setSubmitted(true);
    } catch (err) {
      setError(err?.response?.data?.detail || "Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg-main text-text-primary flex flex-col items-center justify-center px-6 py-10">
      <Link to="/" className="font-bold text-xl tracking-tight mb-8">
        Zen<span className="text-button-primary">cricket</span>data
      </Link>

      <div className="w-full max-w-md bg-bg-primary border border-border-default rounded-2xl p-8 sm:p-10">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-extrabold tracking-tight">Reset your password</h1>
          <p className="text-text-secondary text-sm mt-1">
            We'll email you a link to set a new one.
          </p>
        </div>

        {submitted ? (
          <div className="space-y-4">
            <div className="bg-emerald-500/10 border border-emerald-500/30 rounded-lg p-4 text-sm text-text-primary">
              <p className="font-medium mb-1">Check your inbox</p>
              <p className="text-text-secondary">
                If an account exists for <span className="text-text-primary">{email}</span>,
                a password-reset link is on its way. The link expires in 3 days.
              </p>
            </div>
            <p className="text-text-secondary text-xs text-center">
              Didn't get the email? Check spam, then{" "}
              <button
                onClick={() => { setSubmitted(false); }}
                className="text-button-primary hover:brightness-110"
              >
                try again
              </button>.
            </p>
            <Link
              to="/login"
              className="block text-center mt-2 text-button-primary hover:brightness-110 text-sm font-semibold"
            >
              Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <label className="block mb-4">
              <span className="block text-[10px] uppercase tracking-wider text-text-secondary mb-1.5">
                Email
              </span>
              <input
                type="email"
                className="w-full bg-bg-secondary border border-border-default rounded-lg py-2.5 px-3.5 text-sm text-text-primary placeholder-text-secondary/60 focus:outline-none focus:border-button-primary transition-colors"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoFocus
              />
            </label>

            {error && (
              <div className="bg-button-primary/10 border border-button-primary/30 rounded-lg px-3.5 py-2.5 text-sm text-button-primary mt-3">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="mt-6 w-full bg-button-primary hover:brightness-110 disabled:opacity-50 text-white font-semibold py-3 rounded-lg transition-all"
            >
              {loading ? "Sending…" : "Send reset link"}
            </button>

            <div className="my-6 h-px bg-gradient-to-r from-transparent via-border-default to-transparent" />

            <p className="text-center text-sm text-text-secondary">
              Remembered it?{" "}
              <Link to="/login" className="text-button-primary hover:brightness-110 font-semibold">
                Sign in
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
